import { OTHER_CURRENCIES, TOP_CURRENCIES } from '@/app/constants'

export const getCurrencies = () => {
	return [...TOP_CURRENCIES, ...OTHER_CURRENCIES]
}
